import React, {useState, useEffect} from "react";
import {Formik, Field, Form} from "formik";
import {
   TextField,
   Loading,
   MultiSelect,
   Select,
   PersianDataPicker,
} from "components/form";
import {
   generate_uuid,
   transformTranslateFromValues,
   transformTranslateServerValues,
} from "lib/helpers";
import {required, validationWrapper, isUserName} from "lib/formValidations";

import Modal from "components/Modal";
import {useCore} from "store/core";
import {TextArea} from "components/form";
import {CheckBox} from "components/form";
// components

export default function Add(props) {
   const core = useCore();
   const [prices, setPrices] = useState([]);
   const [showAddPrice, setShowAddPrice] = useState(false);
   const _renderPrices = () => {
      return prices.map((item) => (
         <div className="grid grid-cols-4 gap-2">
            <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
            <h5 className="text-center">{item.amount}</h5>
            <h5 className="text-center">
               <button
                  type="button"
                  className={`btn btn-sm ${item.status ? "btn-success" : "btn-danger"}`}
                  onClick={() => {
                     setPrices([...prices.filter(i => (i.uuid !== item.uuid)), {...item, status: !item.status}])
                  }}>
                  {item.status ? "فعال" : "غیر فعال"}
               </button>
            </h5>
            <div className="flex justify-center items-center">
               <button
                  type="button"
                  onClick={() => {
                     setPrices(prices.filter((i) => i.uuid != item.uuid));
                  }}
                  className="btn btn-sm btn-danger"
               >
                  حذف
               </button>
            </div>
         </div>
      ));
   };
   return (
      <>
         <AddPrices
            close={() => setShowAddPrice(false)}
            show={showAddPrice}
            submit={(values) => {
               setPrices([...prices, values]);
            }}
         />
         <Modal
            zIndex={992}
            show={props.show}
            handleClose={props.close}
            title={props.title}
         >
            <Formik
               initialValues={{}}
               onSubmit={async (values, {setSubmitting}) => {
                  await props.submit({
                     ...transformTranslateFromValues(values),
                     prices,
                  });
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-12 md:gap-3">
                           <div className="col-span-6">
                              <Field
                                 placeholder="نام"
                                 label="نام :"
                                 name="name"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="(en)نام"
                                 label="(en) نام :"
                                 name="_en*name*text"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="توضیحات"
                                 label="توضیحات :"
                                 name="desc"
                                 component={TextArea}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="(en)توضیحات"
                                 label="(en) توضیحات :"
                                 name="_en*desc*text"
                                 component={TextArea}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="مدت زمان(روز)"
                                 label="مدت زمان(روز) :"
                                 name="days_to_expire"
                                 component={TextField}
                                 type="number"
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="فعال"
                                 label="فعال؟"
                                 name="status"
                                 component={CheckBox}
                              />
                           </div>
                           <div className="col-span-6">
                              <Field
                                 placeholder="تمدید خودکار"
                                 label="تمدید خودکار؟"
                                 name="renewable"
                                 component={CheckBox}
                              />
                           </div>
                           <div className="intro-y col-span-12 border rounded p-2 border-theme-21">
                              <div className="flex justify-between items-center">
                                 <h2>قیمت ها :</h2>
                                 <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => setShowAddPrice(true)}
                                 >
                                    افزودن قیمت
                                 </button>
                              </div>
                              <hr className="my-2"/>
                              <div className="grid grid-cols-1 gap-4 mt-3">
                                 <div className="grid grid-cols-4 gap-2">
                                    <h5>واحد پولی</h5>
                                    <h5 className="text-center">مقدار</h5>
                                    <h5 className="text-center">وضعیت</h5>
                                    <div className="flex justify-center items-center">
                                       عملیات
                                    </div>
                                 </div>
                                 {_renderPrices()}
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button
                           className="btn btn-primary w-20"
                           type="submit"
                           disabled={!!(isSubmitting || !dirty)}
                        >
                           {" "}
                           {isSubmitting ? <Loading/> : "ذخیره"}
                        </button>
                        <button
                           type="button"
                           disabled={isSubmitting}
                           onClick={props.close}
                           className="btn btn-outline-secondary w-20 mr-1"
                        >
                           انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}

export function AddPrices(props) {
   return (
      <Modal
         zIndex={1000}
         show={props.show}
         handleClose={props.close}
         title="افزودن قیمت"
      >
         <Formik
            key="fromik_p_price"
            initialValues={{uuid: generate_uuid()}}
            onSubmit={(values, {setSubmitting}) => {
               props.submit(values);
               props.close();
               setSubmitting(false);
            }}
         >
            {({isSubmitting, dirty, handleSubmit}) => (
               <Form>
                  <div className="modal-body gap-y-3">
                     <div className="intro-x grid md:grid-cols-4 md:gap-3">
                        <div></div>
                        <div className="">
                           <Field
                              placeholder="واحد پولی"
                              label="واحد پولی :"
                              name="currency"
                              component={Select}
                              options={[
                                 {value: "IRR", label: "تومان"},
                                 {value: "USD", label: "دلار"},
                              ]}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div className="">
                           <Field
                              placeholder="مقدار"
                              label="مقدار :"
                              name="amount"
                              component={TextField}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                        <div className="">
                           <Field
                              placeholder="فعال"
                              label="فعال؟"
                              name="status"
                              component={CheckBox}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="modal-footer text-right">
                     <button
                        className="btn btn-primary w-20"
                        type="button"
                        onClick={handleSubmit}
                        disabled={!!(isSubmitting || !dirty)}
                     >
                        {isSubmitting ? <Loading/> : "ذخیره"}
                     </button>
                     <button
                        type="button"
                        disabled={isSubmitting}
                        onClick={props.close}
                        className="btn btn-outline-secondary w-20 mr-1"
                     >
                        انصراف
                     </button>
                  </div>
               </Form>
            )}
         </Formik>
      </Modal>
   );
}
